function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.334 -0.000488281H25.6673V11.9995H18.334V-0.000488281Z",
  fill: "#262BBA"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.333984 -0.000488281H7.66732V11.9995H0.333984V-0.000488281Z",
  fill: "#262BBA"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6673 1.50355C10.5021 1.91539 9.66732 3.02663 9.66732 4.33285C9.66732 5.9897 11.0105 7.33285 12.6673 7.33285H13.334C13.5181 7.33285 13.6673 7.48208 13.6673 7.66618C13.6673 7.85027 13.5181 7.99951 13.334 7.99951H10.334V10.6662H11.6673V11.3328H14.334V10.4955C15.4992 10.0836 16.334 8.9724 16.334 7.66618C16.334 6.00932 14.9908 4.66618 13.334 4.66618H12.6673C12.4832 4.66618 12.334 4.51694 12.334 4.33285C12.334 4.14875 12.4832 3.99951 12.6673 3.99951H15.6673V1.33285H14.334V0.666178H11.6673V1.50355Z",
  fill: "#262BBA"
});
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 12,
    viewBox: "0 0 26 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.e6acb16515a8c026752618516ac3bb17.svg";
export { ForwardRef as ReactComponent };